import AdSmart from "@/assets/clients/Client_AdSmart.webp";
import Cemaco from "@/assets/clients/Client_Cemaco.webp";
import Genba from "@/assets/clients/Client_Genba.webp";
import McDonalds from "@/assets/clients/Client_McDonalds.webp";
import Medalspot from "@/assets/clients/Client_Medalspot.webp";
import Millicom from "@/assets/clients/Client_Millicom.webp";
import Must from "@/assets/clients/Client_Must.webp";
import Muveri from "@/assets/clients/Client_Muveri.webp";
import Niva from "@/assets/clients/Client_Niva.webp";
import Nostradamus from "@/assets/clients/Client_Nostradamus.webp";
import Panifresh from "@/assets/clients/Client_Panifresh.webp";
import PASALO from "@/assets/clients/Client_PASALO.webp";
import Presto from "@/assets/clients/Client_Presto.webp";
import SAF from "@/assets/clients/Client_SAF.webp";
import TheSchwank from "@/assets/clients/Client_TheSchwank.webp";
import URVANA from "@/assets/clients/Client_URVANA.webp";
import WEBAN from "@/assets/clients/Client_WEBAN.webp";

type Client = {
  name: string;
  src: string;
  darkLogo?: boolean;
};

const clients: Client[] = [
  { name: "AdSmart", src: AdSmart },
  { name: "Cemaco", src: Cemaco },
  { name: "Genba", src: Genba },
  { name: "McDonald's", src: McDonalds },
  { name: "Medalspot", src: Medalspot },
  { name: "Millicom", src: Millicom },
  { name: "Must", src: Must },
  { name: "Muveri", src: Muveri },
  { name: "Niva", src: Niva },
  { name: "Nostradamus", src: Nostradamus },
  { name: "Panifresh", src: Panifresh },
  { name: "PASALO", src: PASALO },
  { name: "Presto", src: Presto },
  { name: "SAF", src: SAF },
  { name: "The Schwank", src: TheSchwank },
  { name: "URVANA", src: URVANA },
  { name: "WEBAN", src: WEBAN },
];

export function ClientLogoMarquee() {
  const loop = [...clients, ...clients];

  return (
    <div
      className="relative w-full overflow-hidden py-6 lg:py-8 border-t hairline"
      style={{
        maskImage:
          "linear-gradient(to right, transparent, black 8%, black 92%, transparent)",
        WebkitMaskImage:
          "linear-gradient(to right, transparent, black 8%, black 92%, transparent)",
      }}
    >
      <div className="flex w-max animate-marquee gap-16 lg:gap-24">
        {loop.map((c, i) => (
          <div
            key={`${c.name}-${i}`}
            className="flex h-36 md:h-48 lg:h-56 shrink-0 items-center justify-center"
          >
            <img
              src={c.src}
              alt={c.name}
              loading="lazy"
              draggable={false}
              className={
                "h-full w-auto object-contain select-none " +
                (c.darkLogo ? "invert" : "")
              }
            />
          </div>
        ))}
      </div>
    </div>
  );
}
